import { h } from "@stencil/core";
export const renderImg = (cssClass, parts, src, imageType) => imageType === "img" &&
    src && (h("img", { "aria-hidden": "true", class: cssClass, part: parts, alt: "", src: src, loading: "lazy" }));
